import { z } from 'zod'

const envSchema = z.object({
  VITE_APP_NAME: z.string().default('Brand App'),
  VITE_APP_VERSION: z.string().default('0.0.1'),
  // Deployment environment. 'local' disables observability (Sentry); deployed
  // builds set 'staging' or 'production'.
  VITE_APP_ENV: z.enum(['local', 'staging', 'production']).default('local'),
  VITE_API_BASE_URL: z.string().url().default('http://localhost:3001'),
  // Read-only admin keys for the review-apps/test-users dev tools. The staging
  // token reads the review-apps list + brand users on the staging host; review
  // apps authenticate with their own seeded token. Both baked into staging
  // builds only; absent in production.
  VITE_REVIEW_APPS_API_KEY: z.string().optional(),
  VITE_REVIEW_APPS_API_KEY_REVIEW: z.string().optional(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().url().default('https://app.posthog.com'),
  VITE_ENABLE_ANALYTICS: z
    .string()
    .transform((val) => val === 'true')
    .default('false'),
})

function getEnv() {
  const parsed = envSchema.safeParse(import.meta.env)

  if (!parsed.success) {
    console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors)
    throw new Error('Invalid environment variables')
  }

  return parsed.data
}

export const env = getEnv()

export type Env = z.infer<typeof envSchema>
